import React from 'react';
import { Form } from 'react-bootstrap';

interface InputNumberProps {
  /* TODO Replace any/ CORE-1006 */
  /* eslint-disable  @typescript-eslint/no-explicit-any */
  ClassName?: string;
  Feedback?: string;
  HandleChange: (event: any) => void;
  Id: string;
  IsDisabled?: boolean;
  IsInvalid?: boolean;
  IsReadOnly?: boolean;
  IsRequired?: boolean;
  Label?: string;
  Max?: number | string;
  Min?: number | string;
  Name?: string;
  Placeholder?: string;
  Value?: number | string;
}

const InputNumber = ({
  ClassName,
  Feedback,
  HandleChange,
  Id,
  IsDisabled,
  IsInvalid,
  IsReadOnly,
  IsRequired,
  Label,
  Max,
  Min,
  Name,
  Placeholder,
  Value,
}: InputNumberProps) => {
  return (
    <Form.Group className={ClassName} id={Id}>
      {Label && (
        <Form.Label className={IsRequired ? 'required' : ''}>
          {Label}
        </Form.Label>
      )}
      <Form.Control
        disabled={IsDisabled}
        id={Id}
        isInvalid={IsInvalid}
        max={Max}
        min={Min}
        name={Name !== null ? Name : Id}
        onChange={HandleChange}
        placeholder={Placeholder}
        readOnly={IsReadOnly}
        required={IsRequired}
        type="number"
        value={Value}
      />
      {Feedback && IsInvalid && (
        <Form.Control.Feedback type="invalid">{Feedback}</Form.Control.Feedback>
      )}
    </Form.Group>
  );
};

// InputNumber.defaultProps = {
//   ClassName: 'mb-24',
//   Feedback: null,
//   IsDisabled: false,
//   IsInvalid: false,
//   IsReadOnly: false,
//   IsRequired: true,
//   Label: null,
//   Max: null,
//   Min: null,
//   Name: null,
//   Placeholder: null,
//   Value: null,
// };

export default InputNumber;
export { InputNumber };
export type { InputNumberProps };
